<template>
  <div>
    <div class="text-muted small">{{activity.created_at | formatRelativeDate}}</div>
    <!--USER LINK-->
    <UserLink :user="activity.causer" />

    <!--ACTIVITY LOG ACTION-->
    {{ $t('actions.' + $options.filters.slugify(activity.description)) }}

    <!--CREATED-->
    <div v-if="activity.description === 'added'">
      <div v-if="activity.subject">
        <span> {{ $t('maintenance.data_objects.log.title') | lowerCase}}</span>
        <span class="text-info">
          {{activity.subject.data_object.name}}
        </span>
        <span> {{ $t('system.on') }}</span>
        <span> {{ $t('maintenance.third_parties.log.title') }}</span>
        <router-link :to="{ name: 'contracts.view', params: { slug: activity.subject.third_party.slug }}">
            {{activity.properties.third_party.name}}
        </router-link>
      </div>
      <div v-else>
        <span> {{ $t('maintenance.data_objects.log.title') | lowerCase}}</span>
        <span class="text-info">
          {{activity.properties.data_object.name}}
        </span>
        <span> {{ $t('system.on') }}</span>
        <span> {{ $t('maintenance.third_parties.log.title') }}</span>
        <router-link :to="{ name: 'contracts.view', params: { slug: activity.properties.third_party.slug }}">
            {{activity.properties.third_party.name}}
        </router-link>
      </div>
    </div>

    <!--DELETED-->
    <div v-if="activity.description === 'removed'">
      <div v-if="activity.subject">
        <span> {{ $t('maintenance.data_objects.log.title') | lowerCase}}</span>
        <span class="text-info"> {{activity.subject.data_object.name}}</span>
        <span> {{ $t('system.from') }}</span>
        <span> {{ $t('maintenance.third_parties.log.title') }}</span>
        <router-link :to="{ name: 'contracts.view', params: { slug: activity.subject.third_party.slug }}">
            {{activity.properties.third_party.name}}
        </router-link>
      </div>
      <div v-else>
        <span> {{ $t('maintenance.data_objects.log.title') | lowerCase}}</span>
        <span class="text-info"> {{activity.properties.data_object.name}}</span>
        <span> {{ $t('system.from') }}</span>
        <span> {{ $t('maintenance.third_parties.log.title') }}</span>
        <router-link :to="{ name: 'contracts.view', params: { slug: activity.properties.third_party.slug }}">
          {{activity.properties.third_party.name}}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import piincHttp from '@/util/configureAxios.js';
import UserLink from '@/components/user/Link.vue';

export default {
  name: 'ProcessPolicy',
  data: function() {
    return {
        activeNavbar: this.$store.state.activeNavbar,
        items: [],
        currentPage: 1,
        totalRows: 0,
    }
  },
  props: {
      activity: {},
        changes: false
  },
  components:{
      UserLink
  },
  computed: {
      getNavType() {
            return this.$store.state.activeNavbar
      },
      getClient() {
        return this.$store.state.client
      },
  },
      watch: {
      },
  methods: {
    loadContent(page) {
    }
  },
    created () {
    }
}
</script>

<style scoped lang="scss">

</style>
